<app-search [url]="url" [showViewOptions]="false" [showViewPaginator]="false" [showSideBar]="false"></app-search>
